import { lockScroll, unlockScroll } from 'JS/utils/lock-screen';
import Form from "JS/form/Form";
import { notice } from "JS/utils/notice";

class AuthModalController {
    constructor(domElement) {
        if (!document.querySelector('[data-open-auth]')) {
            return;
        }
        this.authModal = domElement;
        this.openAuthBtns = document.querySelectorAll('[data-open-auth]');
        this.tabBtns = this.authModal.querySelectorAll('[data-btn-tab]');
        this.tabWraps = this.authModal.querySelectorAll('[data-auth-tab]');
        this.authModalWrap = this.authModal.querySelector('.auth-modal__container');
        this.closeBtns = this.authModal.querySelectorAll('.close');
        this.loginForm = this.authModal.querySelector('[data-form="login"]') ? new Form(this.authModal.querySelector('[data-form="login"]')) : null;
        this.regForm = this.authModal.querySelector('[data-form="reg"]') ? new Form(this.authModal.querySelector('[data-form="reg"]')) : null;
        this.submitBtns = this.authModal.querySelectorAll('.auth-modal__container-submit');
        this.#init();
    }

    #init() {
        this.#addEventListeners();
    }

    #addEventListeners() {

        this.tabBtns.forEach(element => {
           this.#contentOpen(element);
        });

        this.openAuthBtns.forEach(el => {
            el.addEventListener('click', () => {
            
                if (this.authModal.classList.contains('auth-page')) return;

                if (el.getAttribute('data-open-auth') === 'product') {
                    localStorage.setItem('authFav', 'auth');
                }
    
                this.#openModal();
            });
        });

        this.closeBtns.forEach(el => {
            el.addEventListener('click', () => {
                this.#closeModal();
            });
        });

        if (this.loginForm) {
            this.loginForm.on('submit', (data) => {
                this.#auth(data, 'login');
            });
        }

        if (this.regForm) {
            this.regForm.on('submit', (data) => {
                this.#auth(data, 'reg');
            });
        }

    }

    #contentOpen(element) {
        element.addEventListener('click', () => {
            if (element.classList.contains('active')) return;

            this.#contentHide();
            element.classList.add('active');
            const attrValue = element.dataset.btnTab;
            const currTab = this.authModal.querySelector(`[data-auth-tab="${attrValue}"]`);
            currTab.classList.add('active');

            if (attrValue === 'reg') {
                this.authModalWrap.classList.add('content-scroll');
            } else {  
                this.authModalWrap.classList.remove('content-scroll');
            }
        });
    }

    #contentHide() {
        this.tabBtns.forEach(el => {
            el.classList.remove('active');
        });

        this.tabWraps.forEach(el => {
            el.classList.remove('active');
        });
    }

    #openModal()  {
        this.authModal.classList.add('auth-modal--open');
        this.authModalWrap.classList.add('auth-modal__container--open');
        lockScroll();
    }

    #closeModal()  {
        this.authModal.classList.remove('auth-modal--open');
        this.authModalWrap.classList.remove('auth-modal__container--open');
        localStorage.removeItem('authFav');
        unlockScroll();
    }

    #auth(data, attr) {
        const passInp = this.authModal.querySelector('[data-form="reg"] input[name="pass"]')
        const repeatPassInp = this.authModal.querySelector('input[name="repeat-pass"]');

        if (attr === 'reg' && passInp.value !== repeatPassInp.value) {
            notice('Пароли не совпадают', 'error');
            return;
        }

        const formData = new FormData();

        Object.keys(data).forEach(el => {
            formData.append(el, data[el]);
        });

        if (attr === 'login') {
            formData.append('action', 'login');
        } else {
            formData.append('action', 'register');
        }

        this.#addBtnsProcessing(true);

        fetch(backendData.ajaxUrl, {
            method: "POST",
            body: formData,
        })
        .then((res) => res.json())
        .then((data) => {
            if (data.success) {
                notice(data.data?.message, 'success');
                setTimeout(() => {
                    this.#addBtnsProcessing(false);
                    location.reload();
                }, 1000);
            } else {
                if (data.data?.logged_in) {
                    notice(data.data?.message, 'success');
                    setTimeout(() => {
                        this.#addBtnsProcessing(false);
                        location.reload();
                    }, 1000);
                } else {
                    notice(data.data?.message, 'error'); 
                    this.#addBtnsProcessing(false);
                }
            }
            
        })
        .catch((error) => {
            notice(error, 'error');
        });
    }

    #addBtnsProcessing(attr) {
        this.submitBtns.forEach(el => {
            if (attr) {
                el.classList.add('processing');
            } else {
                el.classList.remove('processing');
            }
        })
    }

}

const authModal = document.querySelector('.auth-page') ? document.querySelector('.auth-page') : document.querySelector('.auth-modal');
const instanceAuthModal = new AuthModalController(authModal);

export default instanceAuthModal;